import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import ValidateDeviceDetectionLoopNumberCommand from 'features/device/domain/models/validate-device-detection-loop-number-command';
import ValidateUniqueDesoResidentTransmitterCommand from 'features/device/domain/models/validate-unique-deso-resident-transmitter-command';

enum DesoQueryPaths {
  ValidateUniqueDesoResidentTransmitter = 'ValidateUniqueDesoResidentTransmitter',
  ValidateDeviceDetectionLoopNumber = 'ValidateDeviceDetectionLoopNumber',
}

const baseUrl = '/api/v1/deso';

const validateUniqueDesoResidentTransmitter = async (
  axios: AxiosInstance,
  body: ValidateUniqueDesoResidentTransmitterCommand,
): Promise<void> => {
  const response = await axios.post(`${baseUrl}/${DesoQueryPaths.ValidateUniqueDesoResidentTransmitter}`, body);
  return response.data;
};

export const useValidateUniqueDesoResidentTransmitter = (): UseMutationResult<
  void,
  Error,
  ValidateUniqueDesoResidentTransmitterCommand,
  unknown
> => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: [DesoQueryPaths.ValidateUniqueDesoResidentTransmitter],
    mutationFn: (body: ValidateUniqueDesoResidentTransmitterCommand) => validateUniqueDesoResidentTransmitter(authenticatedInstance, body),
  });
};

export const validateDeviceDetectionLoopNumber = async (
  axios: AxiosInstance,
  body: ValidateDeviceDetectionLoopNumberCommand,
): Promise<void> => {
  await axios.post(`${baseUrl}/${DesoQueryPaths.ValidateDeviceDetectionLoopNumber}`, body);
};

export const useValidateDeviceDetectionLoopNumber = (): UseMutationResult<
  void,
  Error,
  ValidateDeviceDetectionLoopNumberCommand,
  unknown
> => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: [DesoQueryPaths.ValidateDeviceDetectionLoopNumber],
    mutationFn: (body: ValidateDeviceDetectionLoopNumberCommand) => validateDeviceDetectionLoopNumber(authenticatedInstance, body),
  });
};
